import { ReactNode } from 'react';
import { NotificationProvider } from './hooks/providers/useNotificationProvider';
import { ApplicationProvider } from './hooks/providers/useApplicationProvider';
import { ApplicationUpsaleProvider } from './hooks/providers/useApplicationUpsaleProvider';
import { AuthProvider } from './hooks/providers/useAuthProvider';
import { BanksProvider } from './hooks/providers/useBanksProviders';
import { ClientBudgetProvider } from './hooks/providers/useClientBudgetProviders';
import { ClientConstraintsProvider } from './hooks/providers/useClientConstraintsProvider';
import { ClientHouseholdProvider } from './hooks/providers/useClientHouseholdProvider';
import { ClientOfferProvider } from './hooks/providers/useClientOfferProvider';
import { ClientProvider } from './hooks/providers/useClientProviders';
import { ConfirmationProvider } from './hooks/providers/useConfirmationProvider';
import { ConsentsProvider } from './hooks/providers/useConsentsProvider';
import { DiscountsProvider } from './hooks/providers/useDiscountsProvider';
import { ErrorProvider } from './hooks/providers/useErrorProvider';
import { LatestLoanProvider } from './hooks/providers/useLatestLoanProvider';
import { LegalDocumentProvider } from './hooks/providers/useLegalDocumentsProvider';
import { PSD2ProxyProvider } from './hooks/providers/usePSD2ProxyProvider';
import { LegacyAuthProvider } from '@/pages/Login/LegacyLogin/useLegacyAuth.tsx';

type Props = {
  children: ReactNode;
};

function StateProvider({ children }: Props) {
  return (
    <ErrorProvider>
      <NotificationProvider>
        <AuthProvider>
          <LegacyAuthProvider>
            <ClientProvider>
              <ClientBudgetProvider>
                <ClientConstraintsProvider>
                  <ClientHouseholdProvider>
                    <ClientOfferProvider>
                      <ConsentsProvider>
                        <BanksProvider>
                          <LegalDocumentProvider>
                            <DiscountsProvider>
                              <ApplicationProvider>
                                <LatestLoanProvider>
                                  <ApplicationUpsaleProvider>
                                    <ConfirmationProvider>
                                      <PSD2ProxyProvider>
                                        {children}
                                      </PSD2ProxyProvider>
                                    </ConfirmationProvider>
                                  </ApplicationUpsaleProvider>
                                </LatestLoanProvider>
                              </ApplicationProvider>
                            </DiscountsProvider>
                          </LegalDocumentProvider>
                        </BanksProvider>
                      </ConsentsProvider>
                    </ClientOfferProvider>
                  </ClientHouseholdProvider>
                </ClientConstraintsProvider>
              </ClientBudgetProvider>
            </ClientProvider>
          </LegacyAuthProvider>
        </AuthProvider>
      </NotificationProvider>
    </ErrorProvider>
  );
}

export default StateProvider;
